(function () {
  function getMenuItem(menuRoot) {
    return menuRoot.closest('li.menu_space');
  }

  function getPanel(menuRoot) {
    return menuRoot.querySelector('.menudrop_hover');
  }

  function getRow(panel) {
    return panel.querySelector('.row.mega-menu__list--condensed');
  }

  function clamp(delta, rowRect) {
    const min = -rowRect.left;
    const max = window.innerWidth - rowRect.right;
    return Math.min(Math.max(delta, min), max);
  }

  function update(menuRoot) {
    const menuItem = getMenuItem(menuRoot);
    const panel = getPanel(menuRoot);
    if (!menuItem || !panel) return;

    const row = getRow(panel);
    if (!row) return;

    // reset
    row.style.setProperty('--ly-mm-left', '0px');

    const menuRect = menuItem.getBoundingClientRect();
    const rowRect = row.getBoundingClientRect();

    const menuCenter = menuRect.left + menuRect.width / 2;
    const rowCenter = rowRect.left + rowRect.width / 2;

    let delta = menuCenter - rowCenter;
    delta = clamp(delta, rowRect);

    row.style.setProperty('--ly-mm-left', `${Math.round(delta)}px`);
  }

  function bind() {
    document.querySelectorAll('.header-mega--menu').forEach(menu => {
      menu.addEventListener('mouseenter', () =>
        requestAnimationFrame(() => update(menu))
      );
      menu.addEventListener('focusin', () =>
        requestAnimationFrame(() => update(menu))
      );
    });

    window.addEventListener('resize', () => {
      const open = document.querySelector('.header-mega--menu:hover');
      if (open) update(open);
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind)
    : bind();
})();